import { PureComponent } from 'react'
import { Link } from 'react-router-dom';
import { Button, OverlayTrigger, Tooltip, Alert } from 'react-bootstrap';

import { EvaluationPerformSingle } from './EvaluationPerformSingle'
// import { EvaluationPerformMultiple } from './EvaluationPerformMultiple'
import {
    criteria, criteria_tooltips, str_no_exams_available,
    title_evaluation, default_tooltip_show, default_tooltip_hide
} from '../Consts';

import './Evaluation.css';

export class EvaluationPerform extends PureComponent {

    toggleShowHideCrossProduct = () => {
        var lst = document.getElementsByClassName("showHideCrossProduct");
        for (let i = 0; i < lst.length; i++) {
            if (lst[i].style.display === "") {
                lst[i].style.display = "none";
            }
            else {
                lst[i].style.display = "";
            }
        }
    }

    toggleShowHideDetailsTable = () => {
        var e = document.getElementById("evalSingleTable");
        e.style.visibility !== "visible" ?
            e.style.visibility = "visible" : e.style.visibility = "hidden";
    }

    performMultipleEval = (eR) => {
        if (eR !== null && eR !== undefined) {
            const protoExam = eR[0][1];
            const { numTasks, maxPoints } = eR[0][0];

            let data = {
                numExams: eR.length,
                numTasks: numTasks,
                maxPoints: maxPoints,
                aDegOfSolution: [],
                avgDegOfSolution: 0,
                aAverage: [],
                sumAverage: 0,
                percentageAverage: 0,
                aMaxVals: [],
                maxValPupil: 0,
                percentageMaxVals: 0,
                aRelDistance: [],
            }

            // calc degree of solution average, avg avg :), maxPoints
            for (let t = 0; t < data.numTasks; t++) {
                let sumUpDegOfSolution = 0;
                let sumUpAverage = 0;
                let maxVal = 0;
                for (let e = 0; e < data.numExams; e++) {
                    const exam = eR[e][0];

                    if (exam.aMaxVals[t] > maxVal) {
                        maxVal = exam.aMaxVals[t];
                    }

                    sumUpDegOfSolution += parseFloat(exam.aDegOfSolution[t]);
                    sumUpAverage += parseFloat(exam.aAverage[t]);
                }
                data.aMaxVals.push(maxVal);
                data.aDegOfSolution.push((sumUpDegOfSolution / data.numExams).toFixed(2));
                data.aAverage.push((sumUpAverage / data.numExams).toFixed(2));

            }
            data.avgDegOfSolution = ((data.aDegOfSolution.reduce((a, b) => parseFloat(a) + parseFloat(b), 0)) / data.numTasks).toFixed(2);
            data.sumAverage = (data.aAverage.reduce((a, b) => parseFloat(a) + parseFloat(b), 0)).toFixed(2);
            data.percentageAverage = ((data.sumAverage / data.maxPoints) * 100).toFixed(2);

            // calc rel distance
            for (let t = 0; t < data.numTasks; t++) {
                let minMaxVals = [99999, -1];
                for (let e = 0; e < data.numExams; e++) {
                    const exam = eR[e][0];
                    const avg = parseFloat(exam.aAverage[t]);
                    if (avg < minMaxVals[0]) {
                        minMaxVals[0] = avg;
                    }
                    if (avg > minMaxVals[1]) {
                        // minMaxVals[1] = avg + 0.1;
                        minMaxVals[1] = avg;
                    }
                }
                const maxPoints = parseFloat(protoExam.maxPunkte[0][t + 2].value);
                const relDist = (((minMaxVals[1] - minMaxVals[0]) / maxPoints) * 100).toFixed(2);
                data.aRelDistance.push(relDist);
                if (relDist > 20 &&
                    this.props.parentState.criterion_c !== "yes") {
                    this.props.backCallerSetCriteria(this.props.parentState.criterion_a,
                        this.props.parentState.criterion_b,
                        "yes");
                }
            }

            // find maxValPupil
            let maxValPupil = 0;
            for (let e = 0; e < data.numExams; e++) {
                const exam = eR[e][0];
                if (exam.maxValPupil > maxValPupil) {
                    maxValPupil = exam.maxValPupil;
                }
            }
            data.maxValPupil = maxValPupil;
            data.percentageMaxVals = ((data.maxValPupil / data.maxPoints) * 100).toFixed(2);

            return data;
        }
    }

    performSingleEval = (exam) => {
        let isNaNFlag = false;

        if (exam !== null && exam !== undefined) {
            const maxPunkte = exam.maxPunkte;
            const grid = exam.grid;

            let data = {
                numTasks: maxPunkte[0].length - 3,
                numPupils: grid.length,
                maxValPupil: 0,
                maxPoints: parseFloat(maxPunkte[0][maxPunkte[0].length - 1].value),
                aAverage: [],
                aMaxVals: [],
                aDegOfSolution: [],
                crossProducts: [],
                sumAverage: 0,
                sumMaxVals: 0,
                percentageMaxVals: 0,
                percentageAverage: 0
            }

            // needed for hack
            if (exam.taskNames === null || exam.taskNames === undefined) {
                // || exam.taskNames[0][2].value.length === 0) {
                const columns = exam.columns;
                exam.taskNames = [];
                exam.taskNames[0] = [];
                exam.taskNames[0][0] = "";
                exam.taskNames[0][1] = "";

                for (let i = 0; i < data.numTasks; i++) {
                    exam.taskNames[0][i + 2] = { value: columns[i + 2].label };
                }
            }
            const taskNames = exam.taskNames;

            // --- calc starts here ---
            // make sure init works out fine
            for (let i = 0; i < data.numTasks; i++) {
                data.aAverage[i] = 0.0;
                data.aMaxVals[i] = 0.0;
            }

            // find max for every task (well, and prepare average calc)
            let maxValPupil = 0;
            for (let i = 0; i < data.numPupils; i++) {
                const pupil = grid[i];
                let valPupil = 0;
                for (let j = 0; j < data.numTasks; j++) {
                    // const punkte = parseFloat(pupil[j + 2].value);
                    // const punkte = parseFloat(pupil[j + 2].value) || 0; // should check for NaN

                    let punkte = parseFloat(pupil[j + 2].value);
                    if (isNaN(punkte)) {
                        punkte = 0;
                        isNaNFlag = true;
                    }

                    valPupil += punkte;
                    data.aAverage[j] += punkte;
                    if (data.aMaxVals[j] < punkte) {
                        data.aMaxVals[j] = punkte;
                    }
                }
                if (valPupil > maxValPupil) {
                    maxValPupil = valPupil;
                }
            }
            data.maxValPupil = maxValPupil;

            // calc average
            for (let i = 0; i < data.numTasks; i++) {
                // console.log(mittelwerte[i], data[3])
                data.aAverage[i] = (data.aAverage[i] / data.numPupils).toFixed(2);
            }

            // calc sum of average and max
            data.sumAverage = (data.aAverage.reduce((a, b) => parseFloat(a) + parseFloat(b), 0)).toFixed(2);
            data.sumMaxVals = (data.aMaxVals.reduce((a, b) => parseFloat(a) + parseFloat(b), 0)).toFixed(2);
            data.percentageAverage = ((data.sumAverage / data.maxPoints) * 100).toFixed(2);
            // data.percentageMaxVals = ((data.sumMaxVals / data.maxPoints) * 100).toFixed(2);
            data.percentageMaxVals = ((data.maxValPupil / data.maxPoints) * 100).toFixed(2);

            // calc degree of solution and set criterion a, if needed
            for (let i = 0; i < data.numTasks; i++) {
                data.aDegOfSolution[i] = (((data.aAverage[i]) / maxPunkte[0][i + 2].value) * 100).toFixed(0);
                if ((data.aDegOfSolution[i] < 20 ||
                    data.aDegOfSolution[i] > 80) &&
                    this.props.parentState.criterion_a !== "yes") {
                    this.props.callbackHandleSetCriteria("yes",
                        this.props.parentState.criterion_b,
                        this.props.parentState.criterion_c);
                    // dirty hack :/
                    this.props.parentState.criterion_a = "yes";
                }
            }

            // cross product
            for (let i = 0; i < data.numTasks; i++) {
                let diffs = [];

                diffs.push(taskNames[0][i + 2].value);
                // diffs.push(columns[i + 2].label);

                for (let j = 0; j < data.numTasks; j++) {
                    let diff = Math.abs(data.aDegOfSolution[i] - data.aDegOfSolution[j]);
                    // diffs.push(diff + "%");
                    diffs.push(diff);
                    if (diff > 40 &&
                        this.props.parentState.criterion_b !== "yes") {
                        this.props.callbackHandleSetCriteria(
                            this.props.parentState.criterion_a,
                            "yes",
                            this.props.parentState.criterion_c);
                        // dirty hack :/
                        this.props.parentState.criterion_b = "yes";
                    }
                }
                data.crossProducts.push(diffs);
            }
            // --- calc ends here ---
            // console.log(data);
            if (isNaNFlag) {
                this.props.callbackHandleSetStatusInfo("Bei mindestens einem Ihrer Einträge in der Tabellarischen Ansicht fehlen Eintragungen / Punkte.",
                    "Hinweis: Daten sind unvollständig", "warning");
            }
            return [data, exam];
        }
    }

    render() {
        return (
            <>
                <h5 className="mb-3">{title_evaluation}</h5>
                {/* 
                {this.props.parentState.klassenarbeiten.length === 0 &&
                    <>
                        <Alert variant="warning" className="alert-crits">
                            <h6>Hinweis: {str_no_exams_available}<br />
                                Um eine Analyseschritte durchf&uuml;hren zu k&ouml;nnen, laden Sie bitte mindestens eine
                                Klassenarbeit unter
                                &nbsp;<Link to={linkTriggerExamLoad}>
                                    <Button variant="outline-primary" size="sm">
                                        Klassenarbeiten
                                    </Button>
                                </Link>
                                &nbsp;in das System und werten Sie diese im Anschluss aus.

                            </h6>
                        </Alert>
                    </>
                } */}


                {this.props.parentState.criterion_a === "yes" &&
                    <Alert variant="warning" className="alert-crits p-1">
                        <h6>Hinweis: Es gibt Aufmerksamkeitspunkte bei&nbsp;
                            <OverlayTrigger
                                placement="bottom"
                                delay={{ show: default_tooltip_show, hide: default_tooltip_hide }}
                                overlay={
                                    <Tooltip id="tooltip-top" className="eval-critA-tooltip">
                                        {criteria_tooltips[0]}
                                    </Tooltip>
                                }
                            >
                                <span className="pointerHelp colorCritA">{criteria[0]}</span>
                            </OverlayTrigger>
                        </h6>
                    </Alert>
                }
                {this.props.parentState.criterion_b === "yes" &&
                    <>
                        <Alert variant="warning" className="alert-crits p-1">
                            <h6>Hinweis: Es gibt Aufmerksamkeitspunkte bei&nbsp;
                                <OverlayTrigger
                                    placement="bottom"
                                    delay={{ show: default_tooltip_show, hide: default_tooltip_hide }}
                                    overlay={
                                        <Tooltip id="tooltip-top" className="eval-critB-tooltip">
                                            {criteria_tooltips[1]}
                                        </Tooltip>
                                    }
                                >
                                    <span className="pointerHelp colorCritB">{criteria[1]}</span>
                                </OverlayTrigger>
                            </h6>
                        </Alert>

                    </>
                }


                {/* {this.props.parentState.klassenarbeiten.length > 1 &&
                    <>
                        {
                            this.props.parentState.criterion_c === "yes" &&

                            <Alert variant="warning" className="alert-crits p-1">
                                <h6>Hinweis: Es gibt Aufmerksamkeitspunkte bei&nbsp;
                                    <OverlayTrigger
                                        placement="bottom"
                                        delay={{ show: default_tooltip_show, hide: default_tooltip_hide }}
                                        overlay={
                                            <Tooltip id="tooltip-top" className="eval-critC-tooltip">
                                                {criteria_tooltips[2]}
                                            </Tooltip>
                                        }
                                    >
                                        <span className="pointerHelp colorCritC">{criteria[2]}</span>
                                    </OverlayTrigger>
                                </h6>
                            </Alert>

                        }
                    </>
                } */}

                {(this.props.parentState.criterion_a !== "yes" &&
                    this.props.parentState.criterion_b !== "yes") &&
                    <h6>
                        Hinweis: Es liegen keinerlei Auff&auml;lligkeiten
                        &nbsp;den Kriterien entsprechend vor.
                    </h6>
                }


                <EvaluationPerformSingle parentState={this.props.parentState}
                    callbackPerformSingleEval={this.performSingleEval}
                    callbackSetStausExams={this.props.backCallerSetStausExams}
                    callbackToggleShowHideCrossProduct={this.toggleShowHideCrossProduct}
                    callbackToggleShowHideDetailsTable={this.toggleShowHideDetailsTable} />

            </>
        )
    }
}
